import { IUpdateLogoPayload, IUpdateLogoSuccessPayload } from 'modules/settings/submodules/clients/components/EditClientLogo/store/models';
import { createRequestActions, createSingleAction, RequestType } from 'store/utils';

export const SET_EDIT_LOGO_CLIENT_ID = 'settings/client/SET_EDIT_LOGO_CLIENT_ID';
export const setEditLogoClientId = createSingleAction<
string | null, typeof SET_EDIT_LOGO_CLIENT_ID>(SET_EDIT_LOGO_CLIENT_ID);

export const updateClientLogo = createRequestActions<IUpdateLogoPayload, IUpdateLogoSuccessPayload>(RequestType.Update, 'CLIENT_LOGO', 'settings/client');
